import {Forms} from '../../forms/Forms';
import {ErrorHandlerInterface} from './ErrorHandlerInterface';
import {HasErrorIgnore} from './HasErrorIgnore';

export class PHPSendErrorHandler implements ErrorHandlerInterface {

    SERVICE_ERRORHANDLER = '../../onlinecommon/web/errorHandler.php';

    private message: string;
    private source: string;
    private fileno: number;
    private columnNumber: number;
    private error: Error;

    constructor() {}

    public init(message: string, source?: string, fileno?: number, columnNumber?: number, error?: Error): void {
        this.message = message;
        this.source = source;
        this.fileno = fileno;
        this.columnNumber = columnNumber;
        this.error = error;
        this.send();
    }

    private getFullMessage(): string {
        let message = this.message;
        if (this.source && this.fileno) {
            message += '\n' + this.source + ':' + this.fileno;
        }
        if (this.error && this.error.stack) {
            message += '\n' + this.error.stack;
        }
        if (document.readyState) {
            message += '\nDocument Status: ' + document.readyState;
        }
        if (window.location) {
            message += '\nlocation: ' + window.location;
        }
        return message;
    }

    private send(): void {
        if (this.isSend()) {
            Forms.ajax(this.SERVICE_ERRORHANDLER, {message: this.getFullMessage()});
        }
    }

    /*
     * Исключаем не понятные/не решаемые ошибки
     */
    private isSend(): boolean {
        // Если нет источника ошибки
        if (this.source && !this.source.length) {
            return false;
        }
        if ((new HasErrorIgnore()).execute(this.getFullMessage())) {
            return false;
        }
        return true;
    }

}